import Vue from 'vue';

Vue.filter("currency", function (value) {
    if (typeof value !== 'number') {
        throw new Error('Currency filter received wrong value');
    }
    return `${value.toFixed(2).replace(".", ",")}€`;
});
